/**
 * ACTION_PROVIDERS
 */

import { SessionActions } from './session';
import { RouterActions } from './router';
import { UiActions } from './ui';
import { XprtDataActions } from './xprt-data';
import { ToolsActions } from './tools';
import { APIActions } from './api-actions';
import { EventsActions } from './events';
import { XuxDndCacheActions } from './xux-dnd-cache/xux-dnd-cache.actions';

export * from './base';
export * from './session';
export * from './router';
export * from './xprt-data';
export * from './ui';
export * from './base';
export * from './tools';
export * from './api-actions';
export * from './events';
export * from './xux-dnd-cache';

export const ACTION_PROVIDERS: any[] = [
  UiActions,
  XprtDataActions,
  SessionActions,
  RouterActions,
  ToolsActions,
  APIActions,
  EventsActions,
  XuxDndCacheActions,
];
